export default __webpack_public_path__ + "static/media/s2_male.b18a1d14.wav";